import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, Row, Col, Select, DatePicker, AutoComplete } from 'antd';
import { dayFormatType, formatDay } from '~helpers/day';

class RefundFilter extends React.Component {
  constructor(props) {
    super(props);
    this.defaultSearchParams = {
      pageNumber: 1,
      pageSize: 10,
    };

    this.state = {
      showMore: true,
      landlordSearchResults: [],
      propertySearchResults: [],
      landlordSlug: null,
      propertySlug: null,
    };

    this.refundType = ['ALL', 'DEPOSIT', 'FIRST_RENTAL'];
    this.status = ['ALL', 'NEW', 'PENDING_REFUND', 'REFUND_CONFIRMATION', 'REFUNDED'];
    this.refundFrom = ['ALL', 'ACCOMMODATION_PARTNER', 'STCOM'];
    this.refundTo = ['ALL', 'TENANT', 'STCOM'];
  }

  handleFiliter = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values) {
          const newValues = {
            landlordSlug:
              this.state.landlordSlug && values.landlord ? this.state.landlordSlug : null,
            propertySlug:
              this.state.propertySlug && values.property ? this.state.propertySlug : null,
            orderReferenceId: values.orderReferenceId || null,
            refundType: values.refundType.toLowerCase() !== 'all' ? values.refundType : null,
            status: values.status.toLowerCase() !== 'all' ? values.status : null,
            refundId: values.refundId || null,
            refundFrom: values.refundFrom.toLowerCase() !== 'all' ? values.refundFrom : null,
            refundTo: values.refundTo.toLowerCase() !== 'all' ? values.refundTo : null,
            refundedAtStart: values.refundDate[0]
              ? formatDay(dayFormatType.FILTERPARAMS, values.refundDate[0])
              : null,
            refundedAtEnd: values.refundDate[1]
              ? formatDay(dayFormatType.FILTERPARAMS, values.refundDate[1])
              : null,
          };
          const filters = {
            pageNumber: 1,
            pageSize: 10,
          };

          Object.keys(newValues).map(key => {
            if (newValues[key] || this.props.filters[key]) {
              filters[key] = newValues[key];
            }

            return true;
          });

          this.props.pushState(filters);
        }
      }
    });
  };

  handleResetBtn = () => {
    this.props.form.resetFields();
    this.setState({
      landlordSearchResults: [],
      propertySearchResults: [],
      landlordSlug: null,
      propertySlug: null,
    });
    this.props.history.push({});
  };

  handleShowMoreBtn = () => {
    this.setState({
      showMore: !this.state.showMore,
    });
  };

  handleLandlordChange = e => {
    this.props.searchLandlordList(e, res => {
      this.setState({
        landlordSearchResults: res.search.edges.map(landlord => landlord.node),
      });
    });
  };

  handleLandlordSelect = slug => {
    this.setState({
      landlordSlug: slug,
    });
  };

  handlePropertyChange = e => {
    this.props.searchPropertyList(e, res => {
      this.setState({
        propertySearchResults: res.search.edges.map(property => property.node),
      });
    });
  };

  handlePropertySelect = slug => {
    this.setState({
      propertySlug: slug,
    });
  };

  render() {
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;
    const dateFormat = dayFormatType.UKFORMAT;

    return (
      <div className="refund__filter">
        <Form
          className={classNames('refund__filter__form', {
            'refund__filter__form--more': !this.state.showMore,
          })}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.transfer.table.filter.landlord.label')}
              >
                {getFieldDecorator('landlord', {
                  initialValue: this.props.filters.landlord || null,
                })(
                  <AutoComplete
                    onSelect={this.handleLandlordSelect}
                    onChange={this.handleLandlordChange}
                    placeholder={t('cms.billing.transfer.table.filter.landlord.placeholder')}
                  >
                    <For of={this.state.landlordSearchResults} each="item">
                      <AutoComplete.Option key={item.id} value={item.slug}>
                        {item.name}
                      </AutoComplete.Option>
                    </For>
                  </AutoComplete>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.transfer.table.filter.property.label')}
              >
                {getFieldDecorator('property', {
                  initialValue: this.props.filters.property || null,
                })(
                  <AutoComplete
                    onSelect={this.handlePropertySelect}
                    onChange={this.handlePropertyChange}
                    placeholder={t('cms.billing.transfer.table.filter.property.placeholder')}
                  >
                    <For of={this.state.propertySearchResults} each="item">
                      <AutoComplete.Option key={item.id} value={item.slug}>
                        {item.name}
                      </AutoComplete.Option>
                    </For>
                  </AutoComplete>,
                )}
              </Form.Item>
            </Col>
            <Col
              span={8}
              className={classNames('', { 'refund__filter__col--hidden': this.state.showMore })}
            >
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.transfer.table.filter.booking_number.label')}
              >
                {getFieldDecorator('orderReferenceId', {
                  initialValue: this.props.filters.orderReferenceId || null,
                })(
                  <Input
                    placeholder={t('cms.billing.transfer.table.filter.booking_number.placeholder')}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row
            gutter={24}
            className={classNames('', { 'refund__filter__row--hidden': this.state.showMore })}
          >
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.refund.table.filter.refund_type.lable')}
              >
                {getFieldDecorator('refundType', {
                  initialValue: this.props.filters.refundType || 'ALL',
                })(
                  <Select>
                    <For of={this.refundType} each="type">
                      <Select.Option value={type} key={type}>
                        {t(`cms.billing.refund.table.refund_type.${type.toLowerCase()}`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.refund.table.filter.status.lable')}
              >
                {getFieldDecorator('status', {
                  initialValue: this.props.filters.status || 'ALL',
                })(
                  <Select>
                    <For of={this.status} each="type">
                      <Select.Option value={type} key={type}>
                        {t(`cms.billing.refund.table.refund_status.${type.toLowerCase()}`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.refund.table.filter.refund_number.lable')}
              >
                {getFieldDecorator('refundId', {
                  initialValue: this.props.filters.refundId || null,
                })(
                  <Input
                    placeholder={t('cms.billing.refund.table.filter.refund_number.placeholder')}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row
            gutter={24}
            className={classNames('', { 'refund__filter__row--hidden': this.state.showMore })}
          >
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.refund.table.filter.refund_from.label')}
              >
                {getFieldDecorator('refundFrom', {
                  initialValue: this.props.filters.refundFrom || 'ALL',
                })(
                  <Select>
                    <For of={this.refundFrom} each="type">
                      <Select.Option value={type} key={type}>
                        {t(`cms.billing.refund.table.refund_from.${type.toLowerCase()}`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.refund.table.filter.refund_to.label')}
              >
                {getFieldDecorator('refundTo', {
                  initialValue: this.props.filters.refundTo || 'ALL',
                })(
                  <Select>
                    <For of={this.refundTo} each="type">
                      <Select.Option value={type} key={type}>
                        {t(`cms.billing.refund.table.refund_to.${type.toLowerCase()}`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="refund__filter__item"
                label={t('cms.billing.refund.table.filter.refund_date.lable')}
              >
                {getFieldDecorator('refundDate', {
                  initialValue: [
                    this.props.filters.refundedAtStart,
                    this.props.filters.refundedAtEnd,
                  ],
                })(<DatePicker.RangePicker format={dateFormat} onChange={() => {}} />)}
              </Form.Item>
            </Col>
          </Row>
          <div
            className={classNames('refund__filter__btns', {
              'refund__filter__btns--more': !this.state.showMore,
            })}
          >
            <Button onClick={this.handleResetBtn}>
              {t('cms.billing.transfer.table.filter.reset.btn')}
            </Button>
            <Button
              onClick={this.handleFiliter}
              type="primary"
              style={{ margin: '0 12px' }}
              htmlType="submit"
            >
              {t('cms.billing.transfer.table.filter.search.btn')}
            </Button>
            <button onClick={this.handleShowMoreBtn} className="refund__filter__btn-more">
              {t(`cms.billing.transfer.table.filter.${this.state.showMore ? 'more' : 'less'}.btn`)}
              <LegacyIcon
                type={this.state.showMore ? 'down' : 'up'}
                className="refund__filter__btn-icon"
              />
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

RefundFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filters: PropTypes.object,
  form: PropTypes.object,
  searchLandlordList: PropTypes.func.isRequired,
  searchPropertyList: PropTypes.func.isRequired,
  pushState: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

RefundFilter.defaultProps = {
  t: () => {},
  filters: {},
  form: {},
  searchLandlordList: () => {},
  searchPropertyList: () => {},
  pushState: () => {},
  history: {
    push: () => {},
  },
};

export default Form.create()(RefundFilter);
